import React from 'react'
//import { Box, Grid, ListItemIcon, Menu, MenuItem, MenuList, Tooltip } from "@mui/material"
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import { auth } from "../../firebase"
import { signOut } from 'firebase/auth';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { selectUser } from '../../features/auth/authSlice';
import { Navigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { setUser } from '../../features/auth/authSlice';
import { useLocation } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LogoutIcon from '@mui/icons-material/Logout';
import { Stack , Divider  } from '@mui/material';
//import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
//import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
//import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';

export default function Header(props) {
	const dispatch = useDispatch()
	//const {isAdmin = false} = props;

	const user = useSelector(selectUser)

	const onClickLogOutButton = () => {
		if (user)
			signOut(auth).then(
				response => {
					dispatch(setUser({
						user: null
					}))
					console.log("sign out successfully")
					console.log(user);
				}
			).catch(err => console.log(err))
	}

	// ger menu function
	// const { menuFunc } = props
	// const { title } = props;
	// const {isAdmin} = props
	const { menuFunc, title, isAdmin = false } = props;

	const navigate = useNavigate()
	const navHome = () => {
		navigate("/home")
	}

	let location = useLocation().pathname

	const matches = useMediaQuery('(min-width:600px)');

	// const [anchorEl, setAnchorEl] = React.useState(null);
	// const open = Boolean(anchorEl);
	// const handleOpenUserMenu = (event) => {
	// 	setAnchorEl(event.currentTarget);
	// };
	// const handleClose = () => {
	// 	setAnchorEl(null);
	// };

	//let menuItems = [{ name: "Logout", func: onClickLogOutButton }]

	// const renderIcons = name => {
	// 	switch (name) {
	// 		case "Admin":
	// 			return <AdminPanelSettingsRoundedIcon />
	// 		default:
	// 			return <LogoutRoundedIcon />
	// 	}
	// }
	//#D39365
	//#F29B28
	//#D6682B
	return (
		!user ? <Navigate to="/" /> :
			<AppBar position="sticky" sx={{ backgroundColor: "#D6682B" }}>
				<Toolbar>
					{location.includes("/home")
						?// If the user is on the home page
						<>{matches
							&&// and is not on mobile, display the menu button
							<IconButton
								size="large"
								edge="start"
								color="inherit"
								aria-label="menu"
								sx={{ mr: 2 }}
								onClick={menuFunc}
							>
								<MenuIcon />
							</IconButton>
						}</>
						:// Otherwise show the navigate home button
						<IconButton
							size="large"
							edge="start"
							color="inherit"
							aria-label="home"
							sx={{ mr: 2 }}
							onClick={navHome}
						>
							<HomeIcon />
						</IconButton>
					}
				<Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
					{title}
				</Typography>
				<Stack direction="row" divider={<Divider orientation="vertical" flexItem />}>
					{isAdmin?<Button variant="" color="inherit" endIcon={<AdminPanelSettingsIcon/>} onClick={()=>{navigate("/admin/")}}>Admin</Button>:null}
					<Button variant="" color="inherit" endIcon={<LogoutIcon/>} onClick={onClickLogOutButton}>Log out</Button>
				</Stack>
			</Toolbar>
		</AppBar>
	)
}

// }
// <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
// 	{title}
// </Typography>
// {/* <Button color="inherit" onClick={onClickLogOutButton}>Log out</Button> */}
// <Box sx={{ flexGrow: 0 }}>
// 	<Tooltip title="Open Settings">
// 		<IconButton onClick={handleOpenUserMenu}>
// 			<AccountCircleRoundedIcon fontSize='large' />
// 		</IconButton>
// 	</Tooltip>
// 	<Menu
// 		anchorEl={anchorEl}
// 		id="account-menu"
// 		open={open}
// 		onClose={handleClose}
// 		onClick={handleClose}
// 		PaperProps={{
// 			elevation: 0,
// 			sx: {
// 				overflow: 'visible',
// 				filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
// 				mt: 1.5,
// 				'& .MuiAvatar-root': {
// 					width: 32,
// 					height: 32,
// 					ml: -0.5,
// 					mr: 1,
// 				},
// 				'&:before': {
// 					content: '""',
// 					display: 'block',
// 					position: 'absolute',
// 					top: 0,
// 					right: 14,
// 					width: 10,
// 					height: 10,
// 					bgcolor: 'background.paper',
// 					transform: 'translateY(-50%) rotate(45deg)',
// 					zIndex: 0,
// 				},
// 			},
// 		}}
// 		transformOrigin={{ horizontal: 'right', vertical: 'top' }}
// 		anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
// 	>
// 		{isAdmin ?
// 			<MenuItem onClick={() => navigate("/admin")}>
// 				<Typography>Admin</Typography>
// 				<ListItemIcon>
// 					<AdminPanelSettingsRoundedIcon />
// 				</ListItemIcon>
// 			</MenuItem>
// 			:
// 			[]
// 		}
// 		<MenuItem onClick={onClickLogOutButton}>
// 			<Typography>Log Out</Typography>
// 			<ListItemIcon>
// 				<LogoutRoundedIcon />
// 			</ListItemIcon>
// 		</MenuItem>
// 	</Menu>
// </Box>

// </Toolbar>
// </AppBar>
